/* Publish by EComposer at 2026-10-13 07:10:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nvqhcfidhmm"]=  window.__ectimmers["ecom-nvqhcfidhmm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nvqhcfidhmm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvqhcfidhmm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpsyojikfw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpsyojikfw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9lwrzmuk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9lwrzmuk8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3x11bo2wgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3x11bo2wgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yd5vm95cdz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yd5vm95cdz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-po1kgrw72k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-po1kgrw72k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1i3pnk8uc9b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1i3pnk8uc9b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f7vk38uquz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f7vk38uquz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwrtbsrzoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwrtbsrzoe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvg5w5a8q2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvg5w5a8q2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uw4ypjiopn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uw4ypjiopn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6dl8226cj9q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6dl8226cj9q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkadzs1gzmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkadzs1gzmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvjj7m9hxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvjj7m9hxh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0geawco77ctj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0geawco77ctj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xg2htc2ztaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xg2htc2ztaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8z6lvodixj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8z6lvodixj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-odp6l7yobea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-odp6l7yobea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6de1u1o7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6de1u1o7h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9kdo5pt90tj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9kdo5pt90tj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qps2lr5ogv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qps2lr5ogv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9m90mmi32rn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m90mmi32rn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8s0owradpmy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8s0owradpmy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpdunus15y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpdunus15y9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zabbbbvxzsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zabbbbvxzsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6gdzl7gro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6gdzl7gro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ti8mo70o4yn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ti8mo70o4yn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-migbp1k3uc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-migbp1k3uc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ykg8g0xqne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykg8g0xqne', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gb0qk7a4ixf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gb0qk7a4ixf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7v8rva50z1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7v8rva50z1i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhlit0tfgpk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhlit0tfgpk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-662dkxt6am').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-662dkxt6am', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2nnhoe7stq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2nnhoe7stq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7d0bmt8th7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7d0bmt8th7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2dkr2wwb9q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2dkr2wwb9q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4mhbw9x7o9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4mhbw9x7o9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7vca8j62n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7vca8j62n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6jq1zzdqrt5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6jq1zzdqrt5', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rlboyhtmn5f"]=  window.__ectimmers["ecom-rlboyhtmn5f"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-rlboyhtmn5f"]["sgahh2qog"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-rlboyhtmn5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rlboyhtmn5f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgquccf09x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgquccf09x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y11pzd1db9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y11pzd1db9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xeflbzxfvpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xeflbzxfvpp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dm5b3xrxnvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dm5b3xrxnvt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ruis81j03m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruis81j03m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zsyyd7gkdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zsyyd7gkdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3jp7c9kcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3jp7c9kcn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9ppf62vb5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9ppf62vb5j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tm92t8iis7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tm92t8iis7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tmerq4qq0a9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tmerq4qq0a9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yx343ptozc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yx343ptozc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n2stsi7x59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n2stsi7x59', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-yitr2wag82k"]=  window.__ectimmers["ecom-yitr2wag82k"] || {};
if(!this.$el)return;this.isLive,this.$el,document.querySelector('html[dir="rtl"]');class t extends HTMLElement{constructor(){super(),this.containerWidth=0,this.marqueeWidth=0,this.multiplier=1,this.isMounted=!1,this.styleProp={},this.classNameProp="",this.autoFillProp=!1,this.playProp=!0,this.pauseOnHoverProp=!1,this.pauseOnClickProp=!1,this.directionProp="left",this.speedProp=50,this.delayProp=0,this.loopProp=0,this.gradientProp=!1,this.gradientColorProp="white",this.gradientWidthProp=200,this.rootRef=null,this.containerRef=null,this.marqueeRef=null,this.childrenHtml="",this.interval=0,this.duration=0}checkRTL(){if(this.isMounted&&window.getComputedStyle(this).direction==="rtl")return!0;const i=document.documentElement.getAttribute("dir"),s=document.body.getAttribute("dir");return i==="rtl"||s==="rtl"}static get observedAttributes(){return["style","class-name","auto-fill","play","pause-on-hover","pause-on-click","direction","speed","delay","loop","gradient","gradient-color","gradient-width"]}connectedCallback(){this.isMounted=!0,this.childrenHtml=this.innerHTML,this.render();const i=this.querySelectorAll("img");if(i.length>0){let s=!1;const o=()=>{s||(s=!0,this.interval= window.__ectimmers["ecom-yitr2wag82k"]["ydh02oav3"] = setInterval(()=>this.handle(),500))};setTimeout(o,2e3),Promise.all(Array.from(i).filter(n=>!n.complete).map(n=>new Promise(r=>{n.onload=n.onerror=r}))).then(o)}else setTimeout(()=>{this.handle()},500),this.interval= window.__ectimmers["ecom-yitr2wag82k"]["jwgmzs8a4"] = setInterval(()=>this.handle(),500)}attributeChangedCallback(i,s,o){switch(i){case"style":this.styleProp=o;break;case"class-name":this.classNameProp=o;break;case"auto-fill":this.autoFillProp=o!==null;break;case"play":this.playProp=o!==null;break;case"pause-on-hover":this.pauseOnHoverProp=o=="true";break;case"pause-on-click":this.pauseOnClickProp=o!==null;break;case"direction":const n=this.checkRTL();o=="right"?this.directionProp=n?"right":"left":this.directionProp=n?"left":"right";break;case"speed":this.speedProp=parseInt(o,10)||50;break;case"delay":this.delayProp=parseInt(o,10)||0;break;case"loop":this.loopProp=parseInt(o,10)||0;break;case"gradient":this.gradientProp=o!==null;break;case"gradient-color":this.gradientColorProp=o||"white";break;case"gradient-width":this.gradientWidthProp=parseInt(o,10)||200;break}this.isMounted&&this.render()}render(){const i=this.checkRTL(),s=`
                        --transform: ${this.directionProp==="up"?"rotate(-90deg)":this.directionProp==="down"?"rotate(90deg)":"none"};
                        --width: ${this.directionProp==="up"||this.directionProp==="down"?"100vh":"100%"};
                        --pause-on-hover: ${!this.playProp||this.pauseOnHoverProp?"paused":"running"};
                        display: flex;
                        `,o=`

                        --duration: ${this.duration}s;
                        --play: ${this.playProp?"running":"pause"};
                        --direction: ${this.directionProp==="left"?"normal":"reverse"};
                        --delay: 0s;
                        --iteration-count: infinite;
                        --min-width: ${this.autoFillProp?"auto":"100%"};
                        --percent-start: ${i?"100%":"0%"};
                        --percent-end: ${i?"0%":"-100%"};
                        display: flex;
                    `,n=`
                        <div class="ecom-text-marquee-container ${this.classNameProp}" style="${s}">
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                            <div class="ecom-text-marque-wrapper" style="${o}">
                                ${this.renderChildren()}
                            </div>
                        </div>
                    `;this.innerHTML=n,this.rootRef=this.querySelector(".ecom-text-marquee-container"),this.marqueeRef=this.querySelector(".ecom-text-marque-wrapper")}calculateWidth(){const i=this.rootRef.getBoundingClientRect(),s=this.marqueeRef.getBoundingClientRect();this.containerWidth=i.width>i.height?i.width:i.height,this.marqueeWidth=s.width>s.height?s.width:s.height,this.multiplier=this.autoFillProp&&this.containerWidth&&this.marqueeWidth?Math.ceil(this.containerWidth/this.marqueeWidth)+1:1}calculateDuration(){this.autoFillProp?this.duration=this.marqueeWidth*this.multiplier/this.speedProp:this.duration=this.marqueeWidth<this.containerWidth?this.containerWidth/this.speedProp:this.marqueeWidth/this.speedProp,this.render()}renderChildren(){let i="";for(let s=0;s<this.multiplier;s++)i+=`<div class="ecom-text-marquee-child" style="display: flex">${this.childrenHtml}</div>`;return i}addEventListeners(){this.pauseOnHoverProp&&(this.rootRef.addEventListener("mouseenter",()=>{this.playProp=!1}),this.rootRef.addEventListener("mouseleave",()=>{this.playProp=!0})),this.pauseOnClickProp&&this.rootRef.addEventListener("click",()=>{this.playProp=!this.playProp}),this.marqueeRef.addEventListener("animationiteration",()=>{typeof this.onCycleComplete=="function"&&this.onCycleComplete()}),this.marqueeRef.addEventListener("animationend",()=>{typeof this.onFinish=="function"&&this.onFinish()})}handle(){const i=this;this.duration?clearInterval(i.interval):(i.calculateWidth(),i.calculateDuration(),i.addEventListeners(),i.classList.add("show"))}}customElements.get("ecom-marquee-component")||customElements.define("ecom-marquee-component",t)

                    });
                    
                        document.querySelectorAll('.ecom-yitr2wag82k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yitr2wag82k', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ugwzfa4a1g"]=  window.__ectimmers["ecom-ugwzfa4a1g"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-ugwzfa4a1g"]["896e05cug"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-ugwzfa4a1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugwzfa4a1g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8v1fswfq0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8v1fswfq0o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbnw8bogcxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbnw8bogcxe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzxctnqgb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzxctnqgb9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d75wiwa0mb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d75wiwa0mb6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnpxcdlgp6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnpxcdlgp6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3df9hzrup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3df9hzrup', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jr8s5flo128').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jr8s5flo128', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sd7gqc5fmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sd7gqc5fmc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b137mwlk8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b137mwlk8i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-elkq3y0i98c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-elkq3y0i98c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ycc5oyerx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ycc5oyerx8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a8vuudgyhzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a8vuudgyhzu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}